var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-avatar',{class:{ border: _vm.tag.isVeryBright },style:({ 'background-color': _vm.tag.color }),attrs:{"icon":"label","size":_vm.size,"text-color":_vm.tag.isVeryBright ? 'grey-4' : 'white'}})}
var staticRenderFns = []

export { render, staticRenderFns }